export const INTEGRATION_SETTINGS_FIELDS = {
  // Basic fields
  ORDERS_REPORTING_API_URL: 'ordersReportingApiUrl',
  PLAYER_INFO_SYNC_URL: 'playerInfoSyncUrl',
  PLAYERS_AUTH_WEBHOOK: 'playersAuthWebhook',
  EVENTS_WEBHOOK_URL: 'eventsWebhookUrl',
  EVENTS_V2_WEBHOOK_URL: 'eventsV2WebhookUrl',
  API_URL_PRIMARY_KEY: 'apiUrlPrimaryKey',
  CHECKOUT_PUBLIC_KEY: 'checkoutPublicKey',
  PUBLISHER_TOKEN: 'publisherToken',

  // Deeplink fields
  DEEPLINK_ON: 'deeplinkOn',
  DEEPLINK_JWT_SECRET: 'deeplinkJwtSecret',

  // AppsFlyer fields
  APPSFLYER_INTEGRATION_ON: 'appsFlyerIntegrationOn',
  APPSFLYER_S2S_TOKEN: 'appsFlyerS2SToken',
  APPSFLYER_APPLICATION_ID: 'appsFlyerApplicationID'
} as const;

export const PAYMENT_LINKS_FIELDS = [
  INTEGRATION_SETTINGS_FIELDS.ORDERS_REPORTING_API_URL,
  INTEGRATION_SETTINGS_FIELDS.EVENTS_WEBHOOK_URL,
  INTEGRATION_SETTINGS_FIELDS.EVENTS_V2_WEBHOOK_URL,
  INTEGRATION_SETTINGS_FIELDS.API_URL_PRIMARY_KEY,
  INTEGRATION_SETTINGS_FIELDS.CHECKOUT_PUBLIC_KEY,
  INTEGRATION_SETTINGS_FIELDS.PUBLISHER_TOKEN
] as const;
